var render = function render(){var _vm=this,_c=_vm._self._c;return _c('device-aware',[_c('pc',{attrs:{"slot":"pc"},slot:"pc"}),_c('mobile',{attrs:{"slot":"mobile"},slot:"mobile"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }